<script lang="ts">
import { OrTextV3, OrDateTimeFormatV3 } from '@onereach/ui-components';
import { defineComponent, PropType } from 'vue';


import { QueueAttributes } from '../../types';

export default defineComponent({
  name: 'InfoTable',
  components: {
    OrTextV3,
    OrDateTimeFormatV3,
  },
  props: {
    queueAttributes: {
      type: Object as PropType<QueueAttributes>,
      required: true,
    },
  },
  computed: {
    dateCreated(): Date|null {
      if (this.queueAttributes.CreatedTimestamp) {
        return new Date(parseInt(this.queueAttributes.CreatedTimestamp) * 1000);
      } else { return null;}
    },
  },
});
</script>
<template>
  <div
    class="typography-body-2-regular text-on-background dark:text-on-background-dark h-full"
  >
    <div
      class="flex h-xl flex-row items-center border-b-1 border-solid border-disabled dark:border-disabled-dark"
    >
      <div class="flex w-1/2 px-sm">
        <OrTextV3
          :text="$t('queueInfoForm.availableItems')"
        />
      </div>
      <div class="flex w-1/2 px-sm">
        {{ queueAttributes.ApproximateNumberOfMessages }}
      </div>
    </div>
    <div
      class="flex h-xl flex-row items-center border-b-1 border-solid border-disabled dark:border-disabled-dark"
    >
      <div class="flex w-1/2 px-sm">
        <OrTextV3
          :text="$t('queueInfoForm.currentItems')"
        />
      </div>
      <div class="flex w-1/2 px-sm">
        {{ queueAttributes.ApproximateNumberOfMessagesNotVisible }}
      </div>
    </div>
    <div
      class="flex h-xl flex-row items-center border-b-1 border-solid border-disabled dark:border-disabled-dark"
    >
      <div class="flex w-1/2 px-sm">
        <OrTextV3
          :text="$t('queueInfoForm.pendingItems')"
        />
      </div>
      <div class="flex w-1/2 px-sm">
        {{ queueAttributes.ApproximateNumberOfMessagesDelayed }}
      </div>
    </div>
    <div
      class="flex h-xl flex-row items-center border-b-1 border-solid border-disabled dark:border-disabled-dark"
    >
      <div class="flex w-1/2 px-sm">
        <OrTextV3
          :text="$t('queueInfoForm.maxSize')"
        />
      </div>
      <div class="flex w-1/2 px-sm">
        {{ queueAttributes.MaximumMessageSize }}
      </div>
    </div>
    <div
      class="flex h-xl flex-row items-center border-b-1 border-solid border-disabled dark:border-disabled-dark"
    >
      <div class="flex w-1/2 px-sm">
        <OrTextV3
          :text="$t('queueInfoForm.dateCreated')"
        />
      </div>
      <div class="flex w-1/2 px-sm">
        <OrDateTimeFormatV3
          v-model="dateCreated"
        />
      </div>
    </div>
  </div>
</template>
